module.exports = __webpack_public_path__ + "static/media/sac_ouvert.bf3aebff.png";